<div class="main-banner main-banner-one">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-7 col-md-12">
                <div class="main-banner-content">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="content">
                                <h1>It's time to go <b>Online</b></h1>
                                <p>Whether you are looking to take your business to the next level
                                    and expand online or want to build your big idea into a digital reality
                                    we have the solution for you. We are serving businesses from early stage
                                    startups to businesses established for decades across a multitude of industries.
                                    We are happy to become your digital partner guiding you through cyberspace.</p>
                                <div class="banner-btn">
                                    <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot" aria-hidden="true"></i>Get in Touch<span></span></a>
                                    <a routerLink="/services" class="optional-btn"><i class="bx bx-grid-alt" aria-hidden="true"></i>Explore Services<span></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-md-12">
                <div class="banner-image mbanner-bg-one">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="animate-banner-image" aria-hidden="true"></div>
                        </div>
                    </div>
                    <img fetchpriority="high" src="assets/img/frontImg.jpg" class="mbanner-img"
                        alt="Team collaborating on digital projects at Webstazy One">
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="shape20"><img src="assets/img/—Pngtree—abstract circle technology background_3527873.png" alt="image"></div> -->
    <!-- <div class="shape21"><img src="assets/img/—Pngtree—gold frame  clipart png_5057042.png" alt="image"></div> -->
    <div class="shape19" aria-hidden="true"><img src="assets/img/—Pngtree—abstract circle technology background_3527873.png"
            alt=""></div>
    <div class="shape22" aria-hidden="true"><img src="assets/img/shape/shape21.png" alt=""></div>
    <div class="shape23" aria-hidden="true"><img src="assets/img/shape/shape22.svg" alt=""></div>
    <div class="shape24" aria-hidden="true"><img src="assets/img/shape/shape23.png" alt=""></div>
    <div class="shape26" aria-hidden="true"><img src="assets/img/Shape_new_2.png" alt=""></div>
</div>

<!--



 -->


<div class="features-card-section pt-100 pb-70 bg-f8fbfa">
    <div class="container">
        <div class="row justify-content-center">
            <!-- <div class="col-lg-4 col-sm-6 col-md-6 wow fadeInUp" data-wow-delay=".2s" routerLink="/service-web-design" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}">
                <div class="single-features-card tx-center">
                    <i class='bx bx-code-alt'></i>
                    <h3><a routerLink="/service-web-design">Web Design &amp; Development</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor dolore magna aliqua.</p>
                </div>
            </div> -->
            <!-- <div  class="col-lg-4 col-sm-6 col-md-6 wow fadeInUp " data-wow-delay=".2s" routerLink="/service-custom-cloudbased-sol" -->
            <div class="col-lg-4 col-sm-6 col-md-6 wow fadeInUp " data-wow-delay=".4s" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <div class="single-features-card tx-center serve-height">
                    <i class='bx bx-code-alt'></i>
                    <h3><a routerLink="/service-web-design">Web Design &amp; Development</a></h3>
                    <!-- <h3><a>Web Design &amp; Development</a></h3> -->
                    <p>Gain more exposure, enhance your brand image. Utilize the power of e-commerce or build your new
                        business on cyberspace.</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6 wow fadeInUp " data-wow-delay=".25s" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <div class="single-features-card tx-center serve-height">
                    <i class='bx bxs-devices'></i>
                    <!-- <h3><a>Mobile Application Development</a></h3> -->
                    <h3><a routerLink="/service-mobile-application">Mobile Application Development</a></h3>
                    <p>Harness the power of portability. Be at the fingertips of your customer with the latest mobile
                        technologies.</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6 wow fadeInUp " data-wow-delay=".2s" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <div class="single-features-card tx-center serve-height">
                    <i class='bx bx-cloud'></i>
                    <h3><a routerLink="/service-custom-cloudbased-sol">Custom Cloud based Solutions</a></h3>
                    <!-- <h3><a>Custom Cloud based Solutions</a></h3> -->
                    <p>Tailor-made solutions for your business problems. Whatever your problem is we have a digital
                        solution in our suite.</p>
                </div>
            </div>
            <!-- <div class="col-lg-4 col-sm-6 col-md-6 wow fadeInUp " data-wow-delay=".25s" routerLink="/service-mobile-application" routerLinkActive="active" -->

            <!-- <div class="col-lg-4 col-sm-6 col-md-6 wow fadeInUp " data-wow-delay=".3s" routerLink="/service-digital-media" routerLinkActive="active" -->

            <!-- <div class="col-lg-4 col-sm-6 col-md-6 wow fadeInUp " data-wow-delay=".35s" routerLink="/service-digital-infrastructure"  -->
            <div class="col-lg-4 col-sm-6 col-md-6 wow fadeInUp " data-wow-delay=".3s" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <div class="single-features-card tx-center serve-height">
                    <i class='bx bx-stats'></i>
                    <h3><a routerLink="/service-digital-media">Digital Media Marketing</a></h3>
                    <!-- <h3><a>Digital Media Marketing</a></h3> -->
                    <p>Acculturate to the 21st century with social media and other digital platforms. Gain the attention
                        of your target audience with every penny you spend.</p>
                </div>
            </div>
            <!-- <div class="col-lg-4 col-sm-6 col-md-6 wow fadeInUp " data-wow-delay=".4s" routerLink="/service-web-design" routerLinkActive="active" -->
            <div class="col-lg-4 col-sm-6 col-md-6 wow fadeInUp " data-wow-delay=".35s" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <div class="single-features-card tx-center serve-height">
                    <i class='bx bxl-bitcoin'></i>
                    <h3><a routerLink="/service-digital-infrastructure">Digital Infrastructure &amp; Business Process
                            Management</a></h3>
                    <!-- <h3><a>Digital Infrastructure &amp; Business Process Management</a></h3> -->
                    <p>Move your business to the cloud. Less staff and efficient processes to grow your business.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="services-area bg-right-shape ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="services-content it-service-content">
                <div class="content left-content">
                    <div class="icon">
                        <img class="industry-emblem" loading="lazy" decoding="async"
                            src="assets/img/webstazyW.png" alt="Webstazy One emblem">
                    </div>
                    <h2>Solutions For Any Industry</h2>
                    <p>Whether you have been in business for a century or a budding startup, we have the digital
                        solutions for you. Our diverse client base will affirm that.</p>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Travel
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Luxury Goods
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Finance
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Advertising
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Security
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Education
                            </div>
                        </div>
                    </div>
                    <!-- <a routerLink="/about" class="default-btn"><i class="bx bxs-spreadsheet"></i> Learn More<span></span></a> -->
                </div>
            </div>
            <div class="services-image wow fadeInRight" data-wow-delay=".3s">
                <div class="image">
                    <img loading="lazy" decoding="async" src="assets/img/SolutionFor.jpg"
                        alt="Illustration showing Webstazy One serving travel, finance, security, education and other industries">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="services-area bg-left-color bg-left-shape bg-f4f6fc ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="services-image wow fadeInLeft" data-wow-delay=".3s">
                <div class="image">
                    <img loading="lazy" decoding="async" src="assets/img/wholeBusiness.jpg"
                        alt="Webstazy One team in a workspace reviewing code on screen during a whiteboard planning session">
                </div>
            </div>
            <div class="services-content it-service-content">
                <div class="content">
                    <div class="icon">
                        <!-- <img src="assets/img/wbstazyfav.png" alt="image"> -->
                    </div>
                    <h2>The Whole Business Suite</h2>
                    <p>Integrate with your existing systems and applications and build new systems catering to your
                        needs with innovative solutions and cutting edge technologies.</p>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Cloud Technologies
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Secure Applications
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Artificial Intelligence
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Optimized Products
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> IOT &amp; AMBI
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Quality Frameworks
                            </div>
                        </div>
                    </div>
                    <!-- <a routerLink="/about" class="default-btn"><i class="bx bxs-spreadsheet"></i>Learn More<span></span></a> -->
                </div>
            </div>
        </div>
    </div>
</section>

<section class="video-presentation-area ptb-100">
    <div class="container">
        <!-- <div class="section-title">
            <h2>Why choose us to watch this video know more</h2>
        </div>
        <div class="video-box">
            <img src="assets/img/collect.jpg" class="main-image" alt="image">
            <a href="https://www.youtube.com/watch?v=0gv7OC9L2s8" class="video-btn popup-youtube"><i class="bx bx-play"></i></a>
            <div class="shape1"><img src="assets/img/shape/shape1.png" alt="image"></div>
            <div class="shape2"><img src="assets/img/shape/shape2.png" alt="image"></div>
            <div class="shape3"><img src="assets/img/shape/shape3.png" alt="image"></div>


        </div> -->
        <div class="funfacts-inner">
            <div class="row">
                <div class="col-lg-3 col-6 col-sm-6">
                    <div class="single-funfacts funfact-style-two wow fadeInLeft" data-wow-delay=".2s">
                        <i class='bx bx-show-alt funfacts-i'></i>
                        <h3><span class="odometer" data-count="1,000,000">00</span><span class="sign-icon">+</span></h3>
                        <p>Users Served</p>
                    </div>
                </div>
                <div class="col-lg-3 col-6 col-sm-6">
                    <div class="single-funfacts funfact-style-two wow fadeInLeft" data-wow-delay=".4s">
                        <!-- <i class='bx bx-list-check funfacts-i' ></i> -->
                        <i class='bx bx-check-double funfacts-i'></i>
                        <h3><span class="odometer" data-count="40">00</span><span class="sign-icon">+</span></h3>
                        <p>Completed Projects</p>
                    </div>
                </div>
                <div class="col-lg-3 col-6 col-sm-6">
                    <div class="single-funfacts funfact-style-two wow fadeInLeft" data-wow-delay=".6s">
                        <!-- <i class='bx bx-smile funfacts-i' ></i> -->
                        <i class='bx bxs-heart-circle funfacts-i '></i>
                        <h3><span class="odometer" data-count="20">00</span><span class="sign-icon">+</span></h3>
                        <p>Happy Clients</p>
                    </div>
                </div>
                <div class="col-lg-3 col-6 col-sm-6 wow fadeInLeft" data-wow-delay=".8s">
                    <div class="single-funfacts funfact-style-two">
                        <i class='bx bx-joystick-button funfacts-i'></i>
                        <h3><span class="odometer" data-count="6">00</span><span class="sign-icon"></span></h3>
                        <p>Unique products</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="contact-cta-box mwidth-1000 wow fadeInUp" data-wow-delay=".3s">
            <div>
                <h3>Ready to take your business online?</h3>
                <p>Tell us about your idea and we'll help you find the right digital solution.</p>
            </div>
            <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot" aria-hidden="true"></i>Get in Touch<span></span></a>
        </div>
    </div>
    <div class="shape-map1" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/map1.png" alt=""></div>
    <div class="shape7" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/shape/shape7.png" alt=""></div>
    <div class="shape8" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/shape/shape8.png" alt=""></div>
    <div class="shape9" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/shape/shape9.png" alt=""></div>
</section>


<section class="features-area pt-100 pb-70 bg-f4f6fc">
    <div class="container">
        <div class="section-title">
            <h2>Our Promises</h2>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="features-box-one wow fadeInLeft OurPro" data-wow-delay=".2s">
                    <!-- <i class='bx bx-conversation bg-13c4a1'></i> -->
                    <i class='bx bx-timer bg-13c4a1'></i>
                    <h3>On Time, Within Budget</h3>
                    <p>Delivering your requirements to suit your budget and helping your business grow with an agile
                        approach.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="features-box-one wow fadeInLeft OurPro" data-wow-delay=".4s">
                    <!-- <i class='bx bxs-badge-check bg-6610f2'></i> -->
                    <i class='bx bxs-extension bg-13c4a1'></i>
                    <h3>Long Term Partnerships</h3>
                    <p>Let's grow together. We will be with you to throughout your journey of digital growth.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="features-box-one wow fadeInLeft OurPro" data-wow-delay=".6s">
                    <!-- <i class='bx bxs-dashboard bg-ffb700'></i> -->
                    <i class='bx bxs-shapes bg-13c4a1'></i>
                    <h3>Tailored for your needs</h3>
                    <p>Addressing unique need of you and your organization rather than providing out of the shelf
                        solutions.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="features-box-one wow fadeInUp OurPro" data-wow-delay=".2s">
                    <!-- <i class='bx bxs-bell-ring bg-fc3549'></i> -->
                    <i class='bx bxs-zap bg-13c4a1'></i>
                    <h3>High Performance Products</h3>
                    <p>Products that will not keep your customers waiting while utilizing your resources efficiently.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="features-box-one wow fadeInUp OurPro" data-wow-delay=".4s">
                    <!-- <i class='bx bxs-info-circle bg-00d280'></i> -->
                    <i class='bx bxs-user-detail bg-13c4a1'></i>
                    <h3>Top User Experience</h3>
                    <p>Products specially designed to grab your target audience and to keep them engaged.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="features-box-one wow fadeInUp OurPros" data-wow-delay=".6s">
                    <!-- <i class='bx bx-cog bg-ff612f'></i> -->
                    <i class='bx bxs-check-shield bg-13c4a1'></i>
                    <h3>Guaranteed Security</h3>
                    <p>Your systems are well protected from hackers, crackers, worms and bugs of the cyberspace with our
                        expertise.</p>
                </div>
            </div>
            <div id="clientele-title"></div>
        </div>
    </div>

</section>

<!-- <section class="partner-area pt-5 pb-70 bg-f8fbfa"  >
    <div class="container">
        <div class="row align-items-center pb-0">
            <div class="trademarks-heading">
                <h1>Our Clientele</h1>
            </div>
            <div class="col-lg-12 col-md-12 ">
                <div class="partner-slides owl-carousel owl-theme ">
                    <div class="single-partner-item ">
                        <a>
                           <img src="assets/img/clients-image/Client_wimaladarma.PNG" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                           <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                           <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                           <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 col-md-12 pt-4 pl-lg-5 pr-lg-5 clientail-second">
                <div class="partner-slides-1 owl-carousel owl-theme ">
                    <div class="single-partner-item ">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                           <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                           <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                           <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                           <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- <section class="feedback-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Whats Our Clients Said About <span>Jexsa</span></h2>
        </div>
        <div class="feedback-slides owl-carousel owl-theme">
            <div class="single-feedback-item">
                <img src="assets/img/woman1.png" alt="image">
                <div class="feedback-desc">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse.</p>
                    <div class="rating">
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                    </div>
                    <div class="client-info">
                        <h3>Sarah Taylor</h3>
                        <span>CEO at Envato</span>
                    </div>
                </div>
            </div>
            <div class="single-feedback-item">
                <img src="assets/img/woman2.png" alt="image">
                <div class="feedback-desc">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse.</p>
                    <div class="rating">
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                    </div>
                    <div class="client-info">
                        <h3>Olivar Lucy</h3>
                        <span>CEO at EnvyTheme.com</span>
                    </div>
                </div>
            </div>
            <div class="single-feedback-item">
                <img src="assets/img/man1.png" alt="image">
                <div class="feedback-desc">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse.</p>
                    <div class="rating">
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                    </div>
                    <div class="client-info">
                        <h3>Steven Smith</h3>
                        <span>CEO at Envato</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>  -->

<!-- <section class="pricing-area pt-100 pb-70 bg-f4f5fe">
    <div class="container">
        <div class="section-title">
            <h2>Choose The Pricing Plan</h2>
        </div>
        <div class="tab pricing-list-tab">
            <ul class="tabs">
                <li><a href="#"><i class="bx bxs-calendar-check"></i> Monthly</a></li>
                <li><a href="#"><i class="bx bxs-calendar-check"></i> Yearly</a></li>
            </ul>
            <div class="tab_content">
                <div class="tabs_item">
                    <div class="row">
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-pricing-table left-align">
                                <div class="pricing-header">
                                    <h3>Free</h3>
                                </div>
                                <div class="price">
                                    <sup>$</sup>0 <sub>/ monthly</sub>
                                </div>
                                <ul class="pricing-features">
                                    <li><i class="bx bxs-badge-check"></i> Up to 3 chat operators <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> 100 ChatBot Triggers</li>

                                    <li><i class="bx bxs-badge-check"></i> 24/7 Live Chat</li>

                                    <li><i class="bx bxs-badge-check"></i> Email Integration <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Messenger Integration</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Info</li>

                                    <li><i class="bx bxs-badge-check"></i> Mobile + Desktop Apps</li>

                                    <li><i class="bx bxs-badge-check"></i> Quick Responses <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Drag & Drop Widgets</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Notes <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Google Analytics</li>
                                </ul>
                                <div class="btn-box">
                                    <a href="#" class="default-btn"><i class="bx bxs-hot"></i> Try It Free Now<span></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-sm-6">
                            <div class="single-pricing-table left-align">
                                <div class="pricing-header">
                                    <h3>Starter</h3>
                                </div>
                                <div class="price">
                                    <sup>$</sup>49 <sub>/ monthly</sub>
                                </div>
                                <ul class="pricing-features">
                                    <li><i class="bx bxs-badge-check"></i> Up to 4 chat operators <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> 150 ChatBot Triggers</li>

                                    <li><i class="bx bxs-badge-check"></i> 24/7 Live Chat</li>

                                    <li><i class="bx bxs-badge-check"></i> Email Integration <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Messenger Integration</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Info</li>

                                    <li><i class="bx bxs-badge-check"></i> Mobile + Desktop Apps</li>

                                    <li><i class="bx bxs-badge-check"></i> Quick Responses <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Drag & Drop Widgets</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Notes <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Google Analytics</li>
                                </ul>
                                <div class="btn-box">
                                    <a href="#" class="default-btn"><i class="bx bxs-hot"></i> Try It Free Now<span></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-sm-6 offset-lg-0 offset-sm-3">
                            <div class="single-pricing-table left-align">
                                <div class="pricing-header">
                                    <h3>Professional</h3>
                                </div>
                                <div class="price">
                                    <sup>$</sup>79 <sub>/ monthly</sub>
                                </div>
                                <ul class="pricing-features">
                                    <li><i class="bx bxs-badge-check"></i> Up to 7 chat operators <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> 250 ChatBot Triggers</li>

                                    <li><i class="bx bxs-badge-check"></i> 24/7 Live Chat</li>

                                    <li><i class="bx bxs-badge-check"></i> Email Integration <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Messenger Integration</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Info</li>

                                    <li><i class="bx bxs-badge-check"></i> Mobile + Desktop Apps</li>

                                    <li><i class="bx bxs-badge-check"></i> Quick Responses <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Drag & Drop Widgets</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Notes <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Google Analytics</li>
                                </ul>
                                <div class="btn-box">
                                    <a href="#" class="default-btn"><i class="bx bxs-hot"></i> Try It Free Now<span></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tabs_item">
                    <div class="row">
                        <div class="col-lg-4 col-md-6">
                            <div class="single-pricing-table left-align">
                                <div class="pricing-header">
                                    <h3>Free</h3>
                                </div>
                                <div class="price">
                                    <sup>$</sup>0 <sub>/ yearly</sub>
                                </div>
                                <ul class="pricing-features">
                                    <li><i class="bx bxs-badge-check"></i> Up to 3 chat operators <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> 100 ChatBot Triggers</li>

                                    <li><i class="bx bxs-badge-check"></i> 24/7 Live Chat</li>

                                    <li><i class="bx bxs-badge-check"></i> Email Integration <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Messenger Integration</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Info</li>

                                    <li><i class="bx bxs-badge-check"></i> Mobile + Desktop Apps</li>

                                    <li><i class="bx bxs-badge-check"></i> Quick Responses <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Drag & Drop Widgets</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Notes <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Google Analytics</li>
                                </ul>
                                <div class="btn-box">
                                    <a href="#" class="default-btn"><i class="bx bxs-hot"></i> Try It Free Now<span></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="single-pricing-table left-align">
                                <div class="pricing-header">
                                    <h3>Starter</h3>
                                </div>
                                <div class="price">
                                    <sup>$</sup>79 <sub>/ yearly</sub>
                                </div>
                                <ul class="pricing-features">
                                    <li><i class="bx bxs-badge-check"></i> Up to 4 chat operators <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> 150 ChatBot Triggers</li>

                                    <li><i class="bx bxs-badge-check"></i> 24/7 Live Chat</li>

                                    <li><i class="bx bxs-badge-check"></i> Email Integration <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Messenger Integration</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Info</li>

                                    <li><i class="bx bxs-badge-check"></i> Mobile + Desktop Apps</li>

                                    <li><i class="bx bxs-badge-check"></i> Quick Responses <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Drag & Drop Widgets</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Notes <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Google Analytics</li>
                                </ul>
                                <div class="btn-box">
                                    <a href="#" class="default-btn"><i class="bx bxs-hot"></i> Try It Free Now<span></span></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                            <div class="single-pricing-table left-align">
                                <div class="pricing-header">
                                    <h3>Professional</h3>
                                </div>
                                <div class="price">
                                    <sup>$</sup>99 <sub>/ yearly</sub>
                                </div>
                                <ul class="pricing-features">
                                    <li><i class="bx bxs-badge-check"></i> Up to 7 chat operators <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> 250 ChatBot Triggers</li>

                                    <li><i class="bx bxs-badge-check"></i> 24/7 Live Chat</li>

                                    <li><i class="bx bxs-badge-check"></i> Email Integration <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Messenger Integration</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Info</li>

                                    <li><i class="bx bxs-badge-check"></i> Mobile + Desktop Apps</li>

                                    <li><i class="bx bxs-badge-check"></i> Quick Responses <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Drag & Drop Widgets</li>

                                    <li><i class="bx bxs-badge-check"></i> Visitor Notes <span class="tooltips bx bxs-info-circle" data-toggle="tooltip" data-placement="right" title="Tight pants next level keffiyeh you probably haven't heard of them."></span></li>

                                    <li><i class="bx bxs-badge-check"></i> Google Analytics</li>
                                </ul>
                                <div class="btn-box">
                                    <a href="#" class="default-btn"><i class="bx bxs-hot"></i> Try It Free Now<span></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- <section class="team-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Explore Our Impacts</h2>
        </div>
        <div class="row">
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-team-box wow fadeInUp" data-wow-delay=".2s">
                    <div class="image">
                        <img src="assets/img/team-image/img1.jpg" alt="image">
                        <ul class="social">
                            <li><a href="#" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-twitter"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-linkedin"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                        </ul>
                    </div>
                    <div class="content">
                        <h3>Wimaladharma &amp; Sons Project</h3>
                        <span>CEO & Founder</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-team-box wow fadeInUp" data-wow-delay=".4s">
                    <div class="image">
                        <img src="assets/img/team-image/img2.jpg" alt="image">
                        <ul class="social">
                            <li><a href="#" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-twitter"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-linkedin"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                        </ul>
                    </div>
                    <div class="content">
                        <h3>Wolters Project</h3>
                        <span>UX/UI Designer</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-team-box wow fadeInUp" data-wow-delay=".6s">
                    <div class="image">
                        <img src="assets/img/team-image/img3.jpg" alt="image">
                        <ul class="social">
                            <li><a href="#" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-twitter"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-linkedin"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                        </ul>
                    </div>
                    <div class="content">
                        <h3>Shipping Asia Project</h3>
                        <span>Web Developer</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-team-box wow fadeInUp" data-wow-delay=".8s">
                    <div class="image">
                        <img src="assets/img/team-image/img4.jpg" alt="image">
                        <ul class="social">
                            <li><a href="#" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-twitter"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-linkedin"></i></a></li>
                            <li><a href="#" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                        </ul>
                    </div>
                    <div class="content">
                        <h3>Flower project</h3>
                        <span>Support</span>
                    </div>
                </div>
                <div  id="Partnerships-title"></div>
            </div>
        </div>
    </div>
</section> -->

<!-- <section class="our-loving-clients ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="section-title">
            <h2>Our Clientele</h2>
        </div>
        <div class="clients-logo-list align-items-center">
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".2s">
                <a href="#">
                    <img src="assets/img/clients-image/img1.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".4s">
                <a href="#">
                    <img src="assets/img/clients-image/img2.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".6s">
                <a href="#">
                    <img src="assets/img/clients-image/img3.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".8s">
                <a href="#">
                    <img src="assets/img/clients-image/img4.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1s">
                <a href="#">
                    <img src="assets/img/clients-image/img5.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.2s">
                <a href="#">
                    <img src="assets/img/clients-image/img6.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.4s">
                <a href="#">
                    <img src="assets/img/clients-image/img7.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.6s">
                <a href="#">
                    <img src="assets/img/clients-image/img8.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.8s">
                <a href="#">
                    <img src="assets/img/clients-image/img9.png" alt="image">
                </a>
            </div>
        </div>
    </div>
</section> -->

<!-- <section class="our-loving-clients ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="section-title">
            <h2>Our Partnerships</h2>
        </div>
        <div class="clients-logo-list align-items-center">
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".2s">
                <a href="#">
                    <img src="assets/img/clients-image/img1.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".4s">
                <a href="#">
                    <img src="assets/img/clients-image/img2.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".6s">
                <a href="#">
                    <img src="assets/img/clients-image/img3.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay=".8s">
                <a href="#">
                    <img src="assets/img/clients-image/img4.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1s">
                <a href="#">
                    <img src="assets/img/clients-image/img5.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.2s">
                <a href="#">
                    <img src="assets/img/clients-image/img6.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.4s">
                <a href="#">
                    <img src="assets/img/clients-image/img7.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.6s">
                <a href="#">
                    <img src="assets/img/clients-image/img8.png" alt="image">
                </a>
            </div>
            <div class="single-clients-logo wow fadeInUp" data-wow-delay="1.8s">
                <a href="#">
                    <img src="assets/img/clients-image/img9.png" alt="image">
                </a>
            </div>
        </div>
    </div>
</section> -->


<!--
<section class="partner-area pt-5 pb-70 bg-f8fbfa">
    <div class="container">
        <div class="row align-items-center pb-0">
            <div class="trademarks-heading">
                <h1>Our Clientele</h1>
            </div>
            <div class="col-lg-12 col-md-12  pl-lg-5 pr-lg-5 clientail-second">
                <div class="partner-slides-1 owl-carousel owl-theme ">
                    <div class="single-partner-item ">
                        <a>
                            <img class="karoslImg"
                                src="assets/img/clients-image/wimaladharma_logoArtboard 1.png" alt="image">
                        </a>
                    </div>

                    <div class="single-partner-item">
                        <a>
                            <img class="karoslImg" src="assets/img/clients-image/real_Life_.png"
                                alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img class="karoslImg" src="assets/img/clients-image/katlas_Holdings_logo.png"
                                alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img class="karoslImg" src="assets/img/clients-image/prime_luck_logo.png"
                                alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img class="karoslImg" src="assets/img/clients-image/temphurs_logo.png"
                                alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img class="karoslImg" src="assets/img/clients-image/Dark_sky_logo.png"
                                alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img class="karoslImg" src="assets/img/clients-image/niranjan_property_logo.png"
                                alt="image">
                        </a>
                    </div>
                </div>
            </div>
          <div class="col-lg-12 col-md-12 pt-4">
                <div class="partner-slides owl-carousel owl-theme ">
                    <div class="single-partner-item ">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                    <div class="single-partner-item">
                        <a>
                            <img src="assets/img/clients-image/img1.png" alt="image">
                        </a>
                    </div>
                </div>
            </div>
        
        </div>
    </div>
</section>


-->
<!-- <div class="subscribe-content border-radius-0">
    <h2>We always try to be the best support to you as possible</h2>
    <form class="newsletter-form">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8">
                <input type="email" class="input-newsletter" placeholder="info@webstazy.one" name="EMAIL" required>
            </div>
            <div class="col-lg-4 col-md-4">
                <button type="submit"><i class="bx bxs-hot"></i> Contact Me</button>
            </div>
        </div>
    </form>
     <div class="shape14"><img src="assets/img/Shape_new_1.png" alt="image"></div>
    <div class="shape17"><img src="assets/img/Shape_new_2.png" alt="image"></div>
</div> -->

<section class="faq-area ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-12">
                <div class="faq-accordion">
                    <h2>Get To Know About <span>Webstazy One</span></h2>
                    <div class="accordion" id="accordionEx" role="tablist" aria-multiselectable="true">
                        <div class="card">
                            <div class="card-header" role="tab" id="headingOne">
                                <a data-bs-toggle="collapse" data-bs-parent="#accordionEx" href="#collapseOne"
                                    aria-expanded="true" aria-controls="collapseOne">
                                    How do I get a website done for my business? <i class="bx bx-plus"></i>
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" role="tabpanel" aria-labelledby="headingOne"
                                data-bs-parent="#accordionEx">
                                <div class="card-body">
                                    You can browse through our portfolio to see our work and let us know how you'd like
                                    to build your website. If you have no clue how, we are still with you. Just tell us
                                    what you need to achieve on cyberspace, Our analysts and Engineers will make it a
                                    reality.
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" role="tab" id="headingTwo">
                                <a class="collapsed" data-bs-toggle="collapse" data-bs-parent="#accordionEx"
                                    href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    Why should I choose Webstazy One? <i class="bx bx-plus"></i>
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" role="tabpanel" aria-labelledby="headingTwo"
                                data-bs-parent="#accordionEx">
                                <div class="card-body">
                                    Anyone can make a website. There are over a billion websites on the world wide web
                                    today. You would need an expert by your side to make your brandname, message,
                                    products or services to stand out from the rest.
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" role="tab" id="headingThree">
                                <a class="collapsed" data-bs-toggle="collapse" data-bs-parent="#accordionEx"
                                    href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    What is the guarantee of quality that I get? <i class="bx bx-plus"></i>
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" role="tabpanel" aria-labelledby="headingThree"
                                data-bs-parent="#accordionEx">
                                <div class="card-body">
                                    We are using the latest yet well tested technologies, tools and frameworks. We
                                    aspire to get guarantee of ISO 25010 Quality Certification for our products in the
                                    near future.
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" role="tab" id="headingFour">
                                <a class="collapsed" data-bs-toggle="collapse" data-bs-parent="#accordionEx"
                                    href="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    I want to know more about your products. <i class="bx bx-plus"></i>
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" role="tabpanel" aria-labelledby="headingFour"
                                data-bs-parent="#accordionEx">
                                <div class="card-body">
                                    We are the vendor of several digital products in the Social, Travel and Automotive
                                    space including FML - fast moving life, Lanka Traveling and Islanders Network.
                                </div>
                            </div>
                        </div>
                        <div class="card mb-0">
                            <div class="card-header" role="tab" id="headingFive">
                                <a class="collapsed" data-bs-toggle="collapse" data-bs-parent="#accordionEx"
                                    href="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    I want to know more about Webstazy One partnerships. <i class="bx bx-plus"></i>
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" role="tabpanel" aria-labelledby="headingFive"
                                data-bs-parent="#accordionEx">
                                <div class="card-body">
                                    Rather than providing you with a product once, we offer long term collaborations
                                    assisting you to maintain and grow with your needs over time.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-md-12">
                <div class="faq-image wow fadeInUp" data-wow-delay=".2s">
                    <img loading="lazy" decoding="async" src="assets/img/getToKnow-2.jpg"
                        alt="Get to know Webstazy One — illustrated FAQ visual">
                </div>
            </div>
        </div>
    </div>
</section>



<!-- <section class="blog-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Our Latest News</h2>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post wow fadeInUp" data-wow-delay=".2s">
                    <div class="post-image">
                        <a routerLink="/blog-details"><img src="assets/img/blog-image/img1.jpg" alt="image"></a>
                        <div class="date"><i class='bx bx-calendar'></i> Oct 14, 2020</div>
                    </div>
                    <div class="post-content">
                        <h3><a routerLink="/blog-details">50 world-changing work, We lost in the 2010s</a></h3>
                        <div class="post-info">
                            <div class="post-by">
                                <img src="assets/img/author-image/img1.jpg" alt="image">
                                <h6>Sarah Taylor</h6>
                            </div>
                            <div class="details-btn">
                                <a routerLink="/blog-details"><i class="bx bx-right-arrow-alt"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post wow fadeInUp" data-wow-delay=".4s">
                    <div class="post-image">
                        <a routerLink="/blog-details"><img src="assets/img/blog-image/img2.jpg" alt="image"></a>
                        <div class="date"><i class='bx bx-calendar'></i> Oct 16, 2020</div>
                    </div>
                    <div class="post-content">
                        <h3><a routerLink="/blog-details">Don't buy a tech gift until you read these rules</a></h3>
                        <div class="post-info">
                            <div class="post-by">
                                <img src="assets/img/author-image/img2.jpg" alt="image">
                                <h6>Michel John</h6>
                            </div>
                            <div class="details-btn">
                                <a routerLink="/blog-details"><i class="bx bx-right-arrow-alt"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="single-blog-post wow fadeInUp" data-wow-delay=".6s">
                    <div class="post-image">
                        <a routerLink="/blog-details"><img src="assets/img/blog-image/img3.jpg" alt="image"></a>
                        <div class="date"><i class='bx bx-calendar'></i> Oct 18, 2020</div>
                    </div>
                    <div class="post-content">
                        <h3><a routerLink="/blog-details">The golden rule of buying a phone as a gift</a></h3>
                        <div class="post-info">
                            <div class="post-by">
                                <img src="assets/img/author-image/img3.jpg" alt="image">
                                <h6>Lucy Eva</h6>
                            </div>
                            <div class="details-btn">
                                <a routerLink="/blog-details"><i class="bx bx-right-arrow-alt"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="blog-notes wow fadeInUp" data-wow-delay=".8s">
                    <p>Insights to help you do what you do better, faster and more profitably. <a routerLink="/blog-1">Read Full Blog</a></p>
                </div>
            </div>
        </div>
    </div>
</section> -->